module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/apelv5-1a81c758d25039fea2ad5f23d9f9c3a8.jpg";